export const entrance = [
  {
    key:'apply',
    label:window.$xinI18n('申请','Home-getBodyDOM-shenqing'),
    icon:'file-text-line', 
    link:'/staff/approve/apply-page',
    isShow:false,
    fn:(applyList:any[],appSetting:any)=>{
      return {
        isShow: appSetting.apply==1
      }
    }
  },
  {
    key:'leave',
    label:window.$xinI18n('请假','approveTypeToNameArr-leave'),
    icon:'Nav_kqqr',
    link:'',
    isShow:false,
    fn:(applyList:any[],switchObj:any)=>{
      const attendanceApply = applyList.find((i)=>i.groupId == 2)
      let baseApplyList = attendanceApply ? attendanceApply.baseApplyList : [];
      let apply = baseApplyList.find((item: any) => item.flow_type == 4);
      if(switchObj.apply && apply){
        return {isShow:true, link:`/staff/approve/apply-form?flowType=${apply.flow_type}&flowSettingId=${apply.flow_setting_id}`}
      }else{
        return { isShow:false }
      }
    }
  },
  {
    key:'goOut',
    label:window.$xinI18n('外出','approveTypeToNameArr-outside'),
    icon:'suitcase-2-line',
    link:'',
    isShow:false,
    fn:(applyList:any[],switchObj:any)=>{
      const attendanceApply = applyList.find((i)=>i.groupId == 2)
      let baseApplyList = attendanceApply ? attendanceApply.baseApplyList : [];
      let apply = baseApplyList.find((item: any) => item.flow_type == 5);
      if(switchObj.apply && apply){
        return {isShow:true, link:`/staff/approve/apply-form?flowType=${apply.flow_type}&flowSettingId=${apply.flow_setting_id}`}
      }else{
        return { isShow:false }
      }
    }
  },
  {
    key:'workOvertime',
    label:window.$xinI18n('加班','ApproveV2-approveNameEmun-overTime'),
    icon:'alarm-line',
    link:'',
    isShow:false,
    fn:(applyList:any[],switchObj:any)=>{
      const attendanceApply = applyList.find((i)=>i.groupId == 2)
      let baseApplyList = attendanceApply ? attendanceApply.baseApplyList : [];
      let apply = baseApplyList.find((item: any) => item.flow_type == 9);
      if(switchObj.apply && apply){
        return {isShow:true, link:`/staff/approve/apply-form?flowType=${apply.flow_type}&flowSettingId=${apply.flow_setting_id}`}
      }else{
        return { isShow:false }
      }
    }
  },
  {
    key:'approveList',
    label:window.$xinI18n('我的审批','Home-getUpdatingDOM-wodeshenpi'),
    icon:'Navmap_approval',
    link:'/staff/approve/list',
    isShow:false,
  },
  {
    key:'recruitment',
    label:window.$xinI18n('我的招聘','home-wodezhaopin'),
    icon:'Navmap_recruit',
    link:'/staff/recruitment/list',
    isShow:false,
  },
  {
    key:'okr',
    label:window.$xinI18n('我的OKR','Okr-OkrList-wodeokr'),
    icon:'Nav_okr',
    link:'/staff/performance/okr',
    isShow:false,
  },
  {
    key:'kpi',
    label:window.$xinI18n('我的绩效','performance-PerformanceList-wodejixiao'),
    icon:'Nav_tj',
    link:'/staff/performance/list',
    isShow:false,
  },
  {
    key:'contract',
    label:window.$xinI18n('电子合同','Home-Home-getBodyDOM-dianzihetong'),
    icon:'Navmap_contract',
    link:'/staff/contract/list',
    isShow:false,
  },
  {
    key:'payroll',
    label:window.$xinI18n('我的工资条','home-wodegongzitiao'),
    icon:'Navmap_salary',
    link:'/staff/payroll/payroll-detail',
    isShow:false,
  },
  {
    key:'attendanceConfirm',
    label:window.$xinI18n('考勤确认','Home-Home-getBodyDOM-kaoqingqueren'),
    icon:'Nav_rwzx',
    link:'/staff/attendance/attendance-detail',
    isShow:false
  },
  {
    key:'bonusPackage',
    label:window.$xinI18n('我的奖金包','home-wodejiangjinbao'),
    icon:'xicon_wallet-3-line',
    link:'/staff/bonus-package',
    isShow:false
  },
  {
    key:'projectManage',
    label:window.$xinI18n('项目管理','projectManagement-xiangmuguanli'),
    icon:'stack-line',
    link:'/staff/project-manage/index',
    isShow:false
  },
  {
    key:'train',
    label:window.$xinI18n('我的培训','home-wodepeixun'),
    icon:'Navmap_training',
    link:'/staff/train/index',
    isShow:false
  },
  {
    key:'employee',
    label:window.$xinI18n('员工端','Nav-Title-yuangongduan'),
    icon:'account-pin-circle-line',
    link:'/staff/home',
    isShow:true
  }
]